import React from 'react';
import BlogHero from '../../../screens/customer/blog/BlogHero';
import BlogPage from '../../../screens/customer/blog/BlogPage';
import MyNavbar from '../../../components/customer/MyNavbar';
import Footer from '../../../components/customer/Footer';

const Blog = () => {
  return (
    <>
      <MyNavbar />
      <BlogHero />
      <BlogPage />
      <Footer />
    </>
  );
};

export default Blog;
